import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetLaundryScheduleIntervalRes } from "types/laundry"

import laundriesService from "api/laundriesService"

const useGetLaundryScheduleInterval = (laundryId: number | null, enabled: boolean) => {
  return useQuery("laundry_schedule_interval", async () => {
    try {
      const res: AxiosResponse<IGetLaundryScheduleIntervalRes> = await laundriesService.getLaundryScheduleInterval(laundryId)

      return res.data
    } catch(err: any) {
      return err.response
    }
  }, { enabled, refetchOnWindowFocus: false })
}

export default useGetLaundryScheduleInterval